import { render, staticRenderFns } from "./TemuBtgConf.vue?vue&type=template&id=c7022f8a&scoped=true"
import script from "./TemuBtgConf.vue?vue&type=script&lang=js"
export * from "./TemuBtgConf.vue?vue&type=script&lang=js"
import style0 from "./TemuBtgConf.vue?vue&type=style&index=0&id=c7022f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7022f8a",
  null
  
)

export default component.exports